import { styled } from "@mui/material/styles";
import { Grid, TextField } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  margin: "10px 0",
});

export const Input = styled(TextField)({
  width: "40%",
});
